var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconTiktok6638Bdf07Edd5E5Cfe0D1D625415764D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.54,
    height: 29.541,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16647",
    d: "M14.77 0A14.77 14.77 0 110 14.77 14.772 14.772 0 0114.77 0zm3.2 6.592c.275 2.321 1.568 3.7 3.81 3.845v2.6A6.02 6.02 0 0118 11.944v4.873c0 6.2-6.76 8.134-9.472 3.695-1.745-2.853-.673-7.877 4.926-8.072v2.76a8.354 8.354 0 00-1.294.319 2.214 2.214 0 00-1.754 2.6c.381 2.667 5.272 3.456 4.864-1.754V6.6h2.7z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconTiktok6638Bdf07Edd5E5Cfe0D1D625415764D);
export default __webpack_public_path__ + "static/media/social-icon-tiktok.6638bdf07edd5e5cfe0d1d625415764d.b03374c74a8e6996b51a5a8ad77602a5.svg";
export { ForwardRef as ReactComponent };